<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-input
          @input.native="onOrdersSearch"
          v-model="search"
          class="input--300"
          type="search"
          placeholder="Search by id"
          name="search"
        />
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__id>
          <div class="table-default__left">ID</div>
        </template>
        <template #id="{ row }">
          <div class="table-default__left">
            <router-link :to="{name: 'product-storage-cash-detail', params: {id: row.id }}" class="table-default__link-border">
              Cash request - {{ row.id }}
            </router-link>
          </div>
        </template>
        <template #date="{ row }">
          {{ dateFormat(row.date) }}
        </template>
        <template #amount="{ row }">
          {{ row.amount.toLocaleString() }} TSh
        </template>
        <template #real_amount="{ row }">
          {{ row.real_amount.toLocaleString() }} TSh
        </template>
        <template #efd_missing="{ row }">
          {{ row.efd_missing.toLocaleString() }} TSh
        </template>
        <template #difference="{ row }">
          {{ row.difference.toLocaleString() }} TSh
        </template>
        <template #responsible="{ row }">
          <template v-if="row.responsible?.first_name">{{ row.responsible.first_name }} {{ row.responsible.last_name }}</template>
          <template v-else>-</template>
        </template>
        <template #taken_by="{ row }">
          <template v-if="row.taken_by?.first_name">{{ row.taken_by.first_name }} {{ row.taken_by.last_name }}</template>
          <template v-else>-</template>
        </template>
        <template #given_by="{ row }">
          <template v-if="row.given_by?.first_name">{{ row.given_by.first_name }} {{ row.given_by.last_name }}</template>
          <template v-else>-</template>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getProductStorageCashRequests } from '@/http'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'

export default {
  name: 'ProductStorageCashActive',
  data() {
    return {
      is_loaded: false,
      search: '',
      table: {
        items: [],
        columns: ['id', 'date', 'amount', 'real_amount', 'efd_missing', 'difference', 'responsible', 'taken_by', 'given_by'],
        options: {
          headings: {
            'id': 'ID',
            'date': 'Date',
            'amount': 'Given amount',
            'real_amount': 'Real amount',
            'efd_missing': 'EFD missing',
            'difference': 'Diff. Value',
            'responsible': 'Responsible',
            'taken_by': 'Taken by',
            'given_by': 'Given by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    onClickPagination(page) {
      this.table_preloader = true
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    fetchItems() {
      getProductStorageCashRequests({ page: this.pagination.page, page_size: 20, search: this.search, status: 'completed' })
        .then(response => {
          this.table.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onOrdersSearch() {
      this.searchUsers(this)
    },
    searchUsers: debounce(vm => {
      vm.pagination.page = 1
      vm.fetchItems()
    }, 350),
  }
}
</script>
